import axiosInstance from '@common/services/axiosIntance/axiosService';
import { SubscriptionPurchase, RequestSubscription } from "react-native-iap";

type CreateIapSubscriptionHistoryDto = {
  subscriptionId: string;
  platform: 'ios' | 'android';
  appBundle: string;
  appVersion: string;
  environment: 'production' | 'sandbox';
  purchaseData: SubscriptionPurchase;
  purchaseRequest: RequestSubscription;
};
export const useIapSubscription = (appId: string) => {
  const createIapSubscriptionHistory = async (
    data: CreateIapSubscriptionHistoryDto
  ) => {
    await axiosInstance({
      method: 'POST',
      url: `/iap-subscription?appId=${appId}`,
      data,
    }).catch(e=>{
      throw e.response?.data
    });
  }

  return {
    createIapSubscriptionHistory
  }
};
export type IapSubscriptionActionsType = ReturnType<typeof useIapSubscription>;